const OPTIONS = [
    { value: 'test', label: 'Test', dot: 'bg-amber-500', active: 'bg-amber-50 text-amber-800 ring-amber-600/30 dark:bg-amber-950 dark:text-amber-200' },
    { value: 'live', label: 'Live', dot: 'bg-emerald-500', active: 'bg-emerald-50 text-emerald-800 ring-emerald-600/30 dark:bg-emerald-950 dark:text-emerald-200' },
];

/**
 * Test | Live switch. Colours match the environment badge on access keys:
 * amber for Test (the draft app), green for Live (the published app).
 */
export default function EnvironmentPicker({ value, onChange, disabled = false }) {
    return (
        <div
            role="radiogroup"
            aria-label="Environment"
            className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5 shadow-sm"
        >
            {OPTIONS.map(option => {
                const selected = value === option.value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        disabled={disabled}
                        onClick={() => !selected && onChange(option.value)}
                        title={option.value === 'live' ? 'Published app (<appId>_live)' : 'Draft app used for testing'}
                        className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1 text-sm font-medium transition-colors disabled:opacity-60 ${
                            selected
                                ? `ring-1 ring-inset ${option.active}`
                                : 'text-gray-600 hover:bg-gray-50 '
                        }`}
                    >
                        <span className={`h-1.5 w-1.5 rounded-full ${option.dot}`} aria-hidden="true" />
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
